import { Field, Label, Switch } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';

export interface ToggleSwitchProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  yesLabel?: string;
  noLabel?: string;
  disabled?: boolean;
}

export function ToggleSwitch({
  label,
  checked,
  onChange,
  yesLabel = 'Yes',
  noLabel = 'No',
  disabled = false,
}: ToggleSwitchProps) {
  return (
    <Field disabled={disabled} className='flex items-center justify-between'>
      <Label className='text-sm font-medium text-gray-900 font-inter cursor-pointer'>
        {label}
      </Label>
      <div className='flex items-center gap-2'>
        <Switch
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className={twMerge(
            'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2',
            checked ? 'bg-primary' : 'bg-gray-200',
            disabled && 'cursor-not-allowed opacity-50'
          )}
        >
          <span
            aria-hidden='true'
            className={twMerge(
              'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
              checked ? 'translate-x-5' : 'translate-x-0'
            )}
          />
        </Switch>
        <span
          className={twMerge(
            'text-sm font-inter min-w-[2rem]',
            checked ? 'text-primary font-medium' : 'text-gray-500'
          )}
        >
          {checked ? yesLabel : noLabel}
        </span>
      </div>
    </Field>
  );
}
